import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PlaceholderChildComponent } from '../../../../../layout/classes/placeholder-child-component.abstract';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'gen-findings-different-compare',
  templateUrl: './findings-different-compare.component.html',
  styleUrls: ['./findings-different-compare.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FindingsDifferentCompareComponent extends PlaceholderChildComponent implements OnInit {
  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.payload = cloneDeep(this.payload);
    this.markChanges();
  }

  private markChanges() {
    for (const key in this.payload['updated']) {
      let value = { value: null, level: null};
      if (this.payload['original'][key] != null) {
        value = this.payload['original'][key].edit
          ? this.payload['original'][key].edit
          : this.payload['original'][key] || value;
      }
      this.payload['updated'][key] = { ...this.payload['updated'][key]};
      this.payload['updated'][key].changed = {
        value: this.payload['updated'][key].value !== value.value,
        level: this.payload['updated'][key].level !== value.level
      };
    }
  }

  beforeClose() {
  }

}
